import {
    http
} from '@/http/axios.js'


// 字典详情
export function dictListApi(params) {
    return http({
        url: `/admin/basic/dict/list`,
        method: 'get',
        params
    })
}


// 字典详情
export function getDictDetail(id) {
    return http({
        url: `/admin/basic/dict/detail`,
        method: 'get',
        params: {id}
    })
}


export function editDict(data) {
    return http({
        url: `/admin/basic/dict/edit`,
        method: 'POST',
        data
    })
}

export function addDict(data) {
    return http({
        url: `/admin/basic/dict/add`,
        method: 'post',
        data
    })
}


export function getDictValues(dictCode) {
    return http({
        url: `/admin/basic/dict-value/list`,
        method: 'get',
        params: {dictCode}
    })
}

export function addDictValue(data) {
    return http({
        url: `/admin/basic/dict-value/add`,
        method: 'post',
        data
    })
}



export function editDictValue(data) {
    return http({
        url: `/admin/basic/dict-value/edit`,
        method: 'POST',
        data
    })
}



export function delDictValue(id) {
    return http({
        url: `/admin/basic/dict-value/del`,
        method: 'POST',
        data: {id}
    })
}

export function getDictValue(id) {
    return http({
        url: `/admin/basic/dict-value/detail`,
        method: 'GET',
        params: {id}
    })
}
